import React, { useState, useEffect, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { feachDocument, updateDocument,createDocument } from '../services/api';
import Skeleton from 'react-loading-skeleton';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LuChevronRight } from "react-icons/lu";
const MyPageBreakEditor = () => {
  const [documents, setDocuments] = useState([]);
    const[loading,setLoading]=useState(false);
  const editorRefs = useRef({});

  useEffect(() => {
    feachDocument()
      .then((res) => {
 
        const fetched = res.data.map((item) => ({
          ...item,
          updatedContent: item.content,
        }));

        setDocuments(fetched);
      })
      .catch((err) => console.error(err));
  }, []);

  // const createdocoumentAction=()=>{
  //   console.log('test');
  //   let data={
  //     title:'ending_page',
  //     content:'asd'
  //   }
  //  const res= createDocument(data);
  //  console.log(res);
  // }

  const handleContentChange = (index, newContent) => {
    const updatedDocs = [...documents];
    updatedDocs[index].updatedContent = newContent;
    setDocuments(updatedDocs);
  };

  const handleSave = (id, index) => {
    setLoading(true);
    const docToUpdate = documents[index];
    updateDocument(id, {
      title: docToUpdate.title,
      content: docToUpdate.updatedContent,
    })
      .then(() => { setLoading(false);toast.success("Document saved!") } )
      .catch((err) => {
        console.error(err);
        toast.error("Error saving document.");
      });
  };

  const insertVariable = (index, variable) => {
    const editor = editorRefs.current[index];
    if (editor && typeof editor.insertContent === 'function') {
      editor.insertContent(variable);
    } else {
      console.warn("Editor instance not ready at index", index);
    }
  };

  const editorConfig = {
    height: 600,
    menubar: true,
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount',
      'emoticons', 'pagebreak', 'print'
    ].join(' '),
    toolbar: [
      'undo redo | formatselect | bold italic underline strikethrough |',
      'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent |',
      'link image media | pagebreak | print preview | code fullscreen |',
      'forecolor backcolor emoticons | table | removeformat | help'
    ].join(' '),
    pagebreak_split_block: true,
    block_formats: 'Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3',
    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
  };
  
  const [sectionOpen, setSectionOpen] = useState('header');
 
  return (
    
    <div className="flex flex-col gap-6 xl:flex-row xl:items-start">
<section className="w-full xl:w-[300px] xl:shrink-0">
 <div className="flex w-full flex-col rounded-lg bg-white dark:bg-darkblack-600">
 <div className="w-full">
 <ul className="overflow-hidden rounded-lg border border-bgray-200 capitalize dark:border-darkblack-400">
  <li onClick={()=>setSectionOpen('header')} className="border-b py-3 hover:bg-gray-100 px-4 cursor-pointer flex justify-between items-center">
    <span>header</span> 
    <span><LuChevronRight /></span>
  </li>
  <li onClick={()=>setSectionOpen('starting_page')}   className="border-b py-3 hover:bg-gray-100 px-4 cursor-pointer flex justify-between items-center">
    <span>Starting Page</span> 
    <span><LuChevronRight /></span>
  </li>

  <li onClick={()=>setSectionOpen('ending_page')}   className="border-b py-3 hover:bg-gray-100 px-4 cursor-pointer flex justify-between items-center">
    <span>Ending Page</span> 
    <span><LuChevronRight /></span>
  </li>


  <li onClick={()=>setSectionOpen('footer')}   className=" py-3 hover:bg-gray-100 px-4 cursor-pointer flex justify-between items-center">
    <span>footer</span> 
    <span><LuChevronRight /></span>
  </li>
</ul>

    </div>
    </div>

  


    </section>
    <section className="w-full min-w-0 flex-1">
   <div className="flex w-full flex-col rounded-lg border border-bgray-200 bg-white p-5 dark:border-darkblack-400 dark:bg-darkblack-600">
   {documents.length > 0 ? (
        <>
         {documents.map((item, index)=> (
            <div key={item.id} className={`mb-6 ${item.title==sectionOpen?'block':'hidden'}`}>
              <p className="mb-2 text-base font-bold leading-[24px] text-bgray-900 dark:text-white capitalize">
                {item.title}
              </p>

              <div className="mb-2 space-x-2">
                <button
                  onClick={() => insertVariable(index, '{startdate}')}
                  className="variable text-white px-3 py-1 rounded"
                >
                  {`{startdate}`}
                </button>
                <button
                  onClick={() => insertVariable(index, '{enddate}')}
                  className="variable text-white px-3 py-1 rounded"
                >
                {`{enddate}`}
                </button>
              </div>

              <Editor
                apiKey="je5nacxm207op1ggch763wdwng62vq9oz0tes12yhhf7nsfj"
                value={item.updatedContent}
                init={editorConfig}
                onInit={(evt, editor) => {
                  editorRefs.current[index] = editor; 
                }}
                onEditorChange={(newContent) => handleContentChange(index, newContent)}
              />
 
              <button
                onClick={() => handleSave(item.id, index)}
                className="mt-3 flex items-center justify-center rounded-lg bg-success-300 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-success-400"
              >
              {loading && (
    <svg
      className="animate-spin h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  )}
    Save
              </button>
            </div>
          ))}
        </>
      ) : (
        <Skeleton count={3} style={{ lineHeight: 20 }} />
      )}       
 

 </div>
</section>

{/* <button onClick={createdocoumentAction}>submit</button> */}
    </div>
  
  );
};

export default MyPageBreakEditor;
